"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _core = require("@emotion/core");

var _utils = require("@tablekit/utils");

var _themes = require("../themes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    to { transform: rotate(360deg); }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var rotationKeyframe = (0, _core.keyframes)(_templateObject());
var Svg = (0, _styledBase["default"])("svg", {
  target: "e1utivrz0",
  label: "Svg"
})("fill:none;stroke:", (0, _utils.getThemeValue)("".concat(_themes.spinnerThemeNamespace, ".fillColor"), _themes.spinnerClassicTheme.fillColor), ";stroke-dasharray:100px;stroke-dashoffset:100px;stroke-width:10px;transform-origin:center;width:100%;height:100%;animation:", rotationKeyframe, " linear 0.86s infinite;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlZFN2Zy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFVc0IiLCJmaWxlIjoic3R5bGVkU3ZnLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGtleWZyYW1lcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuaW1wb3J0IHsgZ2V0VGhlbWVWYWx1ZSB9IGZyb20gJ0B0YWJsZWtpdC91dGlscyc7XG5pbXBvcnQgeyBzcGlubmVyQ2xhc3NpY1RoZW1lLCBzcGlubmVyVGhlbWVOYW1lc3BhY2UgfSBmcm9tICcuLi90aGVtZXMnO1xuXG5jb25zdCByb3RhdGlvbktleWZyYW1lID0ga2V5ZnJhbWVzYFxuICAgIHRvIHsgdHJhbnNmb3JtOiByb3RhdGUoMzYwZGVnKTsgfVxuICBgO1xuXG5jb25zdCBTdmcgPSBzdHlsZWQuc3ZnYFxuICBmaWxsOiBub25lO1xuICBzdHJva2U6ICR7Z2V0VGhlbWVWYWx1ZShcbiAgICBgJHtzcGlubmVyVGhlbWVOYW1lc3BhY2V9LmZpbGxDb2xvcmAsXG4gICAgc3Bpbm5lckNsYXNzaWNUaGVtZS5maWxsQ29sb3JcbiAgKX07XG4gIHN0cm9rZS1kYXNoYXJyYXk6IDEwMHB4O1xuICBzdHJva2UtZGFzaG9mZnNldDogMTAwcHg7XG4gIHN0cm9rZS13aWR0aDogMTBweDtcbiAgdHJhbnNmb3JtLW9yaWdpbjogY2VudGVyO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBhbmltYXRpb246ICR7cm90YXRpb25LZXlmcmFtZX0gbGluZWFyIDAuODZzIGluZmluaXRlO1xuYDtcblN2Zy5kaXNwbGF5TmFtZSA9ICdTcGlubmVyU3ZnJztcbmV4cG9ydCBkZWZhdWx0IFN2ZztcbiJdfQ== */"));
Svg.displayName = 'SpinnerSvg';
var _default = Svg;
exports["default"] = _default;